import {IProfileItemModel, ProfileItemModel} from './profile-item.model';

export interface IZertifikat extends IProfileItemModel {
  uuid?: string;
  beginn?: Date | string;
  schulungsanbieter?: string;
  lehrgang?: string;
  zertifikatnummer?: string;
  uploadId?: string;
  trainingsanbieter?: string;
  forExport?: boolean;
}

export class Zertifikat extends ProfileItemModel implements IZertifikat {
  constructor(
    public uuid?: string,
    public beginn?: Date,
    public schulungsanbieter?: string,
    public lehrgang?: string,
    public zertifikatnummer?: string,
    public uploadId?: string,
    public trainingsanbieter?: string,
    public forExport?: boolean
  ) {
    super();
    this.beginn = beginn ? beginn : new Date(Date.now());
    this.schulungsanbieter = schulungsanbieter ? schulungsanbieter : undefined;
    this.lehrgang = lehrgang ? lehrgang : undefined;
    this.zertifikatnummer = zertifikatnummer ? zertifikatnummer : undefined;
    this.uploadId = uploadId ? uploadId : undefined;
    this.trainingsanbieter = trainingsanbieter ? trainingsanbieter : undefined;
    this.forExport = forExport ? forExport : true;
  }

  static emptyObject(): Zertifikat {
    const s = new Zertifikat();
    s.beginn = new Date();
    s.schulungsanbieter = '';
    s.lehrgang = '';
    s.zertifikatnummer = '';
    s.uploadId = '';
    s.trainingsanbieter = '';
    s.forExport = true;
    return s;
  }

  static fromJson(json: IZertifikat) {
    const zertifikat = new Zertifikat();
    zertifikat.uuid = json.uuid;
    zertifikat.schulungsanbieter = json.schulungsanbieter;
    zertifikat.lehrgang = json.lehrgang;
    zertifikat.beginn = this.anyToDate(json.beginn);
    zertifikat.zertifikatnummer = json.zertifikatnummer;
    zertifikat.uploadId = json.uploadId;
    zertifikat.trainingsanbieter = json.trainingsanbieter;
    zertifikat.forExport = json.forExport;
    return zertifikat;
  }

  newInstance<T extends ProfileItemModel>(): T {
    return new Zertifikat() as T;
  }
}
